<div class="p-grid">
  <p-card class="p-col p-xl-11" header="History for {{label}}">
    <div style="margin-bottom: 1em">
      <p-accordion>
        <p-accordionTab *ngFor="let change of filteredChangeHistory; trackBy historyTrackBy" [transitionOptions]="'0ms'">
          <ng-template pTemplate="header">
            <div class="history-accordion-header">
              <span class="history-accordion-entity-action">
                {{change.dataType}}
                <p-chip
                  label="{{ change.action | titlecase }}"
                  styleClass="text-small history-accordion-chip"
                  aria-label="Type of change"
                ></p-chip>
              </span>

              <time
                class="text-small"
                [dateTime]="change.timestamp.toISODate()"
                aria-label="Date and time of change"
                [pTooltip]="format(change.timestamp)?.toString() ?? ''"
              >
                {{ change.timestamp.toRelative() }}
              </time>
            </div>
          </ng-template>

          <ng-template pTemplate="content">
            <tr>
              <td class="key">
                Database Id
              </td>
              <td class="value">
                {{ change.entityId }}
              </td>
            </tr>
            <tr *ngFor="let item of change.history | keyvalue ">
              <td class="key">{{changeForeignKeyNameSuffix(item.key) | camelCase}}</td>
              <td class="value">{{format(item.value)}}</td>
            </tr>
            <tr>
              <td class="key">
                Last Changed By
              </td>
              <td class="value">
                {{ change.userId }}
              </td>
            </tr>
            <tr>
              <td class="key">
                Last Changed
              </td>
              <td class="value">
                {{ format(change.timestamp) }}
              </td>
            </tr>
          </ng-template>
        </p-accordionTab>
      </p-accordion>
    </div>
  </p-card>
  <div class="p-col p-xl-1">
    <button pButton *ngIf="changeHistory?.length > 0" (click)="exportToExcel()" title="Export" icon="pi pi-file-excel">
    </button>

    <ng-container *ngIf="actionTemplate">
      <ng-container [ngTemplateOutlet]="actionTemplate"></ng-container>
    </ng-container>
  </div>
</div>
